# +++++ Image Class +++++
class Image
    constructor: (el) ->
        @.$el = el
        @.$image = @.$el.querySelector '.image__img'
        @.$imageOverlay = @.$el.querySelector '.image-overlay'
        @.$expandButton = @.$el.querySelector '.image__expand'
        @.expandable = @.$el.classList.contains 'image--expandable'
        @.lazy = @.$el.classList.contains 'image--loading'

        @.$el.classList.add 'image--bound'
        @.InitEvents()
        return

    InitEvents: ->
        self = @
        
        if @.expandable
            @.$expandButton.addEventListener 'click', (e) ->
                imageOverlay = document.importNode(self.$imageOverlay.content,true)
                document.getElementById('site').appendChild imageOverlay
                window.dispatchEvent new CustomEvent('image-overlay-appended', { bubbles: true })
                return
        return


BindImages = ->
    document.querySelectorAll '.image:not(.image--bound)'
        .forEach (el) ->
            new Image el
            return
    return

window.addEventListener 'bind-components', BindImages


# +++++ Image Observer Class +++++
class ImageObserver
    constructor: ->
        @.$lazyImages = []
        @.lazyImageObserver = undefined

        @.RefreshLazyImagesList()
        @.ObserverLazyImages()
        return
    
    ObserverLazyImages: ->
        self = @
        if "IntersectionObserver" of window && "IntersectionObserverEntry" of window && "intersectionRatio" of window.IntersectionObserverEntry.prototype
            if typeof self.lazyImageObserver == "undefined"
                self.lazyImageObserver = new IntersectionObserver((entries, observer) ->
                    entries.forEach (entry) ->
                        if entry.isIntersecting
                            lazyImage = entry.target
                            lazyImage.src = lazyImage.dataset.src
                            lazyImage.classList.remove 'image--lazyload'
                            lazyImage.closest('.image').classList.remove 'image--loading'
                            lazyImage.closest('.image').classList.add 'image--loading-finished'
                            self.lazyImageObserver.unobserve lazyImage.closest('.image')
                )

            self.$lazyImages.forEach (lazyImage) ->
                self.lazyImageObserver.observe lazyImage
                return

        window.addEventListener 'bind-components', (e) ->
            self.RefreshLazyImagesList()
            self.ObserverLazyImages()
            return
    
    RefreshLazyImagesList: ->
        @.$lazyImages = []
        @.$lazyImages = [].slice.call document.querySelectorAll(".image__img.image--lazyload")
        return


window.rsmImageObserver = new ImageObserver()